/**
 * Generates Tailwind CSS classes for a given color using the pattern:
 * bg-{color}-50 border-{color}-200 text-{color}-900
 * 
 * @param {string} color - The color name (e.g., 'green', 'blue', 'red')
 * @returns {string} - The generated CSS classes
 */
export const getColorClasses = (color) => {
  if (!color) {
    return 'bg-gray-50 border-gray-200 text-gray-900';
  }
  
  return `bg-${color}-50 border-${color}-200 text-${color}-900`;
};
